var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative", height: "calc(100vh - 100px)" } },
    [
      _vm.isLoading
        ? _c(
            "v-layout",
            {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                "z-index": "1000",
                background: "rgba(255, 255, 255, .95)"
              },
              attrs: { "align-center": "", "justify-center": "" }
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _c("div", { staticClass: "lds-roller" }, [
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Patientez SVP ...")])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { "ml-3": "", "px-3": "", "py-0": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", "mt-4": "", "mb-3": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs4: "", md3: "" } },
                [
                  _c("base-search-selector", {
                    attrs: {
                      items: _vm.coStates,
                      label: _vm.$t(_vm.lblSetting.ticketState),
                      multiple: ""
                    },
                    model: {
                      value: _vm.fkTicketState,
                      callback: function($$v) {
                        _vm.fkTicketState = $$v
                      },
                      expression: "fkTicketState"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { column: "" } },
            [
              _c(
                "v-flex",
                [
                  _c(
                    "base-infinity-loading",
                    {
                      attrs: {
                        pagination: _vm.pagination,
                        "default-container": false,
                        activityStatus: _vm.activityStatus,
                        parameter: _vm.coSearchParameter,
                        source: _vm.ticketViewModels,
                        "on-fetch": _vm.storeGetTickets,
                        "reset-before-destroy": _vm.storeResetTickets,
                        "set-loader-state": _vm.setTicketLoaderState
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(row) {
                            return [
                              _c("list-item", { attrs: { ticket: row.data } })
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _c("template", { slot: "loader" }, [
                        _c(
                          "div",
                          { staticClass: "mt-3 ml-5" },
                          _vm._l(3, function(n) {
                            return _c("ticket-list-loader", { key: n })
                          }),
                          1
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46dc1eac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46dc1eac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/service-book/tickets_UNUSED/template.html
// module id = null
// module chunks = 